import { useId } from "react";

/**
 * An id that is unique per component instance and safe inside `url(#...)`. A drawing that defines its
 * own gradients needs one: with a fixed id, every copy on the page would paint with the first one's.
 */
export function useSvgId(): string {
  return useId().replaceAll(/[^a-zA-Z0-9_-]/g, "");
}
